import * as Actions from './root-cause-analysis.actions';
import { RootCauseAnalysisStateInterface } from './root-cause-analysis.model';

export const rootCauseAnalysisInitialState: RootCauseAnalysisStateInterface = {
  isRootCauseAnalysisDataLoading: false,
  isRootCauseAnalysisDataLoaded: false,
  isRootCauseAnalysisEquipmentChartVisible: false,
  isRootCauseAnalysisStackChartVisible: false,
  isRootCauseAnalysisTaskChartVisible: false,
  isChartDataLoading: false,
  isChartDataLoaded: false,
  showManyDataWarning: false,
  rootCauseAnalysisData: [],
  chartData: [],
  regularChartData: [],
  dataProgress: 0,
  selectedActivityName: undefined,
  selectedEquipmentName: undefined,
  selectedTaskNames: null,
  selectedRootCauseGroupName: null,
  selectedTreeNodeName: null,
  treePathLoading: false,
  treePathLoaded: false,
  treePathData: null,
};

export function rootCauseAnalysisReducer(
  state: RootCauseAnalysisStateInterface = rootCauseAnalysisInitialState,
  action: Actions.RootCauseAnalysisActions,
): RootCauseAnalysisStateInterface {
  switch (action.type) {
    case Actions.LOAD_OPTIMIZED_ROOT_CAUSE_ANALYSIS_DATA:
    case Actions.START_ROOT_CAUSE_ANALYSIS_DATA_LOADING:
      return {
        ...state,
        dataProgress: 0,
        showManyDataWarning: false,
        rootCauseAnalysisData: [],
        isRootCauseAnalysisDataLoading: true,
        isRootCauseAnalysisDataLoaded: false,
      };

    case Actions.ROOT_CAUSE_ANALYSIS_DATA_LOADED:
      return {
        ...state,
        rootCauseAnalysisData: action.data,
        showManyDataWarning: false,
        isRootCauseAnalysisDataLoaded: true,
        isRootCauseAnalysisDataLoading: false,
      };

    case Actions.ROOT_CAUSE_ANALYSIS_FETCH_DATA:
      return {
        ...state,
        rootCauseAnalysisData: [],
        showManyDataWarning: false,
        isRootCauseAnalysisDataLoaded: false,
        isRootCauseAnalysisDataLoading: true,
      };

    case Actions.ROOT_CAUSE_ANALYSIS_DATA_PROGRESS_SET:
      return {
        ...state,
        dataProgress: action.progress,
      };

    case Actions.ROOT_CAUSE_ANALYSIS_CHART_DATA_LOAD:
      return {
        ...state,
        isChartDataLoading: true,
        isChartDataLoaded: false,
      };

    case Actions.ROOT_CAUSE_ANALYSIS_CHART_DATA_LOADED:
      return {
        ...state,
        chartData: action.data,
        ...(action.isRegularMode ? { regularChartData: action.data } : {}),
        isChartDataLoaded: true,
        isChartDataLoading: false,
      };

    case Actions.ROOT_CAUSE_ANALYSIS_MANY_DATA_WARNING_SHOW:
      return {
        ...state,
        showManyDataWarning: true,
        rootCauseAnalysisData: [],
        isRootCauseAnalysisDataLoaded: true,
        isRootCauseAnalysisDataLoading: false,
      };

    case Actions.ROOT_CAUSE_ANALYSIS_FETCH_ERROR:
      return {
        ...state,
        showManyDataWarning: false,
        isRootCauseAnalysisDataLoaded: true,
        isRootCauseAnalysisDataLoading: false,
        rootCauseAnalysisData: [],
      };

    case Actions.ROOT_CAUSE_ANALYSIS_CHART_FETCH_ERROR:
      return {
        ...state,
        isChartDataLoaded: true,
        isChartDataLoading: false,
        chartData: [],
      };

    case Actions.ROOT_CAUSE_ANALYSIS_COMPARISON_MODE_CHART_VISIBILITY:
      return {
        ...state,
        isRootCauseAnalysisEquipmentChartVisible: action.isRootCauseAnalysisEquipmentChartVisible,
        isRootCauseAnalysisStackChartVisible: action.isRootCauseAnalysisStackChartVisible,
        isRootCauseAnalysisTaskChartVisible: action.isRootCauseAnalysisTaskChartVisible,
        isRootCauseAnalysisDataLoading: false,
        isRootCauseAnalysisDataLoaded: false,
      };

    case Actions.ROOT_CAUSE_ANALYSIS_SET_SELECTED_CHART_DATA:
      return {
        ...state,
        selectedActivityName: action.activityName,
        selectedEquipmentName: action.equipmentName,
        selectedTaskNames: action.taskNames,
        selectedRootCauseGroupName: action.rootCauseGroupName,
        selectedTreeNodeName: action.treeNodeName,
      };
    case Actions.ROOT_CAUSE_ANALYSIS_LOAD_TREE_PATH:
      return {
        ...state,
        treePathLoading: true,
        treePathLoaded: false,
      };

    case Actions.ROOT_CAUSE_ANALYSIS_TREE_PATH_LOADED:
      return {
        ...state,
        treePathLoading: false,
        treePathLoaded: true,
        treePathData: action.data,
      };

    case Actions.ROOT_CAUSE_ANALYSIS_CLEAR_STATE:
      return {
        ...state,
        isRootCauseAnalysisDataLoading: false,
        isRootCauseAnalysisDataLoaded: false,
      };

    default:
      return state;
  }
}
